import { Component, Input, OnDestroy, OnInit } from "@angular/core";
import { Router } from "@angular/router";
import { Subscription } from "rxjs";
import { BaseUrlConstantsService } from "../../../app/services/base-url-constants.service";
import { PowerTrainService } from "../../../app/services/powertrain.service";
import { CommonModule } from "@angular/common";
import { MatIconModule } from "@angular/material/icon";
import { PowertrainModalComponent } from "../powertrain-modal/powertrain-modal.component";
import { MatTooltip, matTooltipAnimations, MatTooltipModule } from "@angular/material/tooltip";
@Component({
  selector: "app-power-train",
  templateUrl: "./power-train.component.html",
  styleUrls: ["./power-train.component.scss"],
  standalone: true,
  imports: [CommonModule,MatIconModule,PowertrainModalComponent,MatTooltipModule,MatTooltip], 
})
export class PowerTrainComponent implements OnInit, OnDestroy {
  sensorpositionUrl = BaseUrlConstantsService.POWERTRAIN_API_SENSORS_POSITION;
  physical_imgs = BaseUrlConstantsService.POWERTRAIN_PHYSICAL_IMG;

  oldParamsSubscription = new Subscription(); 

  @Input("subsystem_id") subsystem_id: number | string;
  @Input('overall_status') overall_status:number|string;

  powertrainImg: string;
  powertrainName: string;
  sensors: any = [];
  assetIds = [];
  powertrainPhyImgs = [];
  oldParams: any = null;
  powertrainObj: any = null;
  client_id: string = null;
  showModal = false;
  showImgModal = false;
  addPhyImgModal=false;
  selectedImg: any = {};

  constructor(private service: PowerTrainService, private router: Router) {}

  ngOnInit(): void {
    this.fetchSensorsPositions();
    this.fetchPhysicalImages();
    this.oldParamsSubscription = this.service.oldDashboardParamsObs.subscribe(
      (params) => {
        this.oldParams = JSON.parse(params)[0];
      }
    );
  }

  ngOnDestroy(): void {
    this.oldParamsSubscription.unsubscribe();
  }

  fetchSensorsPositions() {
    this.service
      // .fetchSensorpositions('http://localhost:7777/powertrain/powertrain/sensor-postions/' + this.subsystem_id)
      .fetchSensorpositions(this.sensorpositionUrl + this.subsystem_id)
      .then((res: any) => {
        const {
          device_position,
          Image_path,
          subsystem_name,
          client_id,
          subsystem_uuid,
          su,
        } = res.data;
        this.client_id = client_id;
        this.powertrainImg = Image_path;
        this.powertrainName = subsystem_name;
        this.sensors = device_position;
        console.log(this.sensors)
        this.powertrainObj = res.data;
      })
      .catch((err) => {
        console.log(err);
      });
  }

  onSensorClick(sensor) {
    let allChild = this.oldParams;
    let sensorData = this.oldParams.connected_sensors.filter(
      (s) => s.id == sensor.asset_id
    )[0];
    localStorage.setItem("MacAddress", sensorData.mac_address);
    const assetChilds = allChild.connected_sensors.filter((x) => {
      return x.device_sno != 1;
    });
    const navigationExtras = {
      skipLocationChange: true,
      queryParams: {
        // pageRef: "managerAssets" === this.pageName ? "managerAssets" : "",
        pageRef: "",
        deviceId: sensorData.inventory_id,
        assetid: sensorData.id,
        label: sensorData.lbl,
        asset_type: sensorData.asset_type,
        sub_type: allChild.sub_type,
        device_serial_no: sensorData.device_sno,
        serial_no: sensorData.sno,
        assetStatus: sensorData.asset_status,
        sensorType: sensorData.sensor,
        no_of_children: assetChilds.length,
        asset_master_info: JSON.stringify(allChild),
        macaddress: sensorData.mac_address,
        kurt_freq: allChild.kurt_freq,
        kurt_threshold: allChild.kurt_threshold,
        kurt_anomaly_counter: allChild.kurt_anomaly_counter,
        route_path: "device-reports",
        outOfService: allChild.out_of_service,
        motor_serial_no: sensorData.motor_serial_no,
        fromPowerTrain: JSON.stringify({
          subsystemId: this.subsystem_id,
          isPowertrainSensor: true,
          overall_status:this.overall_status
        }),
      },
    };
    const params = new URLSearchParams({
      Monitoring_window: "true",
    });
    // this.userID === "390" || this.clientId === "390"
    // if (
    //   this.client_id == "355" ||
    //   localStorage.getItem("associated_clientid") == "355"
    // ) {
    //   localStorage.removeItem("innertab");
    //   localStorage.removeItem("tab");
    //   const newWindowUrl = `/#/detail-nxt?${params}`;

    //   const newWindow = window.open(newWindowUrl, "_blank");

    //   if (newWindow) {
    //     newWindow.addEventListener("load", () => {
    //       newWindow.postMessage(
    //         { type: "passData", data: navigationExtras },
    //         window.location.origin
    //       );

    //       // Send the second message after a delay
    //       setTimeout(() => {
    //         newWindow.postMessage(
    //           { type: "passData", data: navigationExtras },
    //           window.location.origin
    //         );
    //       }, 1000);
    //     });
    //   } else {
    //     console.error("Failed to open new tab. Pop-up blocker may be enabled.");
    //   }
    // } 
    if ( this.client_id == "390" || localStorage.getItem("associated_clientid") == "390") {
      const flags = new URLSearchParams({
        Monitoring_window: 'true'
      }).toString();
    
      const windowName = `detailWindow-${Date.now()}`;
      const childWin = window.open(`/#/detail-nxt?${flags}`, windowName);
    
      if (!childWin) {
        console.error('Popup blocked');
        return;
      }
    
      const onReady = (e: MessageEvent) => {
        if (e.origin === window.location.origin && e.data?.type === 'ready') {
          childWin.postMessage(
            { type: 'init', payload: { data: navigationExtras } },
            window.location.origin
          );
          window.removeEventListener('message', onReady);
        }
      };
    
      window.addEventListener('message', onReady, false);
    }
    else {
      this.router.navigate(["detail-nxt"], navigationExtras);
    }
  }

  editPowertrain(): void {
    this.service.updatePowertrainEditData({
      powertrainImg: this.powertrainImg,
      powertrainName: this.powertrainName,
      powertrainId: this.subsystem_id,
      sensors: this.sensors,
      ...this.powertrainObj,
    });

    this.router.navigate(["powertrain-edit"], { skipLocationChange: true });
  }

  showTooltip(sensor: any): string {
    return `
    Sensor:${sensor.assetType}                  
    Mac:${sensor.mac_address}                
    Sr.No:${sensor.motor_serial}               
    Name:${sensor.sensorMarker}
    `;
  }

  opnePowertrainImageModal() {
    this.showModal = true;
  }
  addImage(){
    this.addPhyImgModal=true;
  }
  
  closeModal(event:any) {
    if(event?.type && event?.type=='savePhyImg'){
      this.addPhyImgModal=false;
      this.fetchPhysicalImages()
    }
    this.addPhyImgModal=false;
    this.showModal = false;
    this.showImgModal = false;
  }

  fetchPhysicalImages() {
    this.service
      .fetchPhysicalImages(`${this.physical_imgs}${this.subsystem_id}`)
      .then((res: any) => {
        this.powertrainPhyImgs = res.data;
      })
      .catch((err: any) => {
        console.log(err);
      });
  }

  openImage(imgObj) {
    this.showImgModal = true;
    this.selectedImg = imgObj;
  }
  closeImage() {
    this.showImgModal = false;
  }
}
